import audience from './audience.svg';
export const AUDIENCE = audience;
